<ng-select
  [labelForId]="id"
  [formControl]="selectControl"
  [items]="items"
  [multiple]="multiple"
  [placeholder]="placeholder"
  [loading]="loading"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [clearable]="clearable"
  [virtualScroll]="virtualScroll"
  [closeOnSelect]="closeOnSelect"
>
  <ng-template ng-option-tmp let-item="item" let-index="index">
    <ng-container *ngIf="optionTemplate">
      <ng-container *ngTemplateOutlet="optionTemplate; context: { item: item, index: index }"></ng-container>
    </ng-container>
    <ng-container *ngIf="!optionTemplate">
      {{ bindLabel ? item[bindLabel] : item }}
    </ng-container>
  </ng-template>

  <ng-template ng-label-tmp let-item="item" let-index="index">
    <ng-container *ngIf="labelTemplate">
      <ng-container *ngTemplateOutlet="labelTemplate; context: { item: item, index: index }"></ng-container>
    </ng-container>
    <ng-container *ngIf="!labelTemplate">
      {{ bindLabel ? item[bindLabel] : item }}
    </ng-container>
  </ng-template>
</ng-select>
